import * as Sentry from '@sentry/vue'
import googleSlideService from '@/services/google-slide'
import config from '@/config'
import GoogleSlideApi from '@/api/googleSlide'
import Util from '@/util'
import Socket from '@/socket'
import SlideApi from '@/api/slide'

const updateGoogleSlideActiveId = ({ commit }, payload) => {
  commit('updateGoogleSlideActiveId', payload)
}

const createNewGoogleSlide = async (context, payload) => {
  try {
    const { dataPayload, item } = payload
    const linkPresenting = `${config.presenterDomain}/integration-google-slide-preseting/?presentationId=${context.state.presentation.id}&uniqueAccessCode=${context.state.presentation.uniqueAccessCode}`
    context.state.isCreatingGoogleSlide = true
    const infor = await googleSlideService.createNewSlideAndSelect(item, linkPresenting)
    dataPayload.googleSlideId = infor.slideId
    dataPayload.order = context.state.presentation.slides.length + 10
    const res = await GoogleSlideApi.createNewGoogleSlide(dataPayload)
    res.body.googleSlide = {
      googleSlideId: dataPayload.googleSlideId,
      slideId: res.body.id,
    }
    return res
  } catch (error) {
    Sentry.captureException(error)
    Util.handleError(error.body ? error.body.message : error)
    return null
  }
}

const updateActiveGoogleSlide = async (context, res) => {
  context.state.presentation.slides.push(res.body)
  context.state.googleSlideActiveId = res.body.id
  context.state.isCreatingGoogleSlide = false
  const payloadSlide = {
    activeSlide: context.state.slideActive.id,
    socketId: Socket.getSocketId(),
    accessCode: context.state.presentation.uniqueAccessCode,
    timestamp: new Date().getTime(),
  }
  SlideApi.updateNextSlideById(context.state.presentation.id, payloadSlide)
}

const createLeaderboardGoogleSlide = async (context, currentSlide) => {
  if (currentSlide.type !== 'pickAnswer') return
  const infor = await googleSlideService.createNewSlideAndSelect({
    ahaIcon: 'leaderboard',
    type: 'leaderboard',
  }, '')
  const payload = {
    presentationId: context.state.presentation.id,
    type: 'leaderboard',
    socketId: Socket.getSocketId(),
    textColour: '#313131',
    baseColour: '#ffffff',
    order: currentSlide.order + 1,
  }
  payload.googleSlideId = infor.slideId
  const res = await GoogleSlideApi.createNewGoogleSlide(payload)
  res.body.googleSlide = {
    googleSlideId: payload.googleSlideId,
    slideId: res.body.id,
  }
  context.state.presentation.slides.push(res.body)
}

export default {
  updateGoogleSlideActiveId,
  createNewGoogleSlide,
  updateActiveGoogleSlide,
  createLeaderboardGoogleSlide,
}
